import React, {createRef} from "react";
import AttachmentsManager from "../../../../gd-components/files/attachments-manager/attachments-manager";
import AttachmentsCollection from "../../../../model2/attachment/attachments";
import {AttachFileMode} from "../../../../gd-components/files/const";
import ButtonAddAttachmentLink from "../../../../gd-components/files/add-attachment-button/add-link";
import FieldProto_FormElement from "../../../proto/render/form-element";

const debug = "FieldAttachments_FormElement"
// const debug = false

export default class FieldAttachments_FormElement extends FieldProto_FormElement {

    public attachmentsRef: React.RefObject<any>

    constructor(props: any) {
        super(props)
        this.attachmentsRef = createRef()
    }

    componentWillUnmount() {
        this.attachmentsRef.current.toggleDropzone(false)
    }

    onSelect = (dataFrom: "local" | "google-drive")=>{
        this.attachmentsRef.current.selectAttachment(dataFrom)
    }

    render(){
        return(
            <div className="attachments-container flex-column-left-center">
                <AttachmentsManager  ref={this.attachmentsRef}
                                     mode={AttachFileMode.VIEW_AND_EDIT}
                                     className="m-t-15"
                                     attachmentsCollection={new AttachmentsCollection([])}
                                     dropzoneDOMElementId={this.props.configOptions.dropzoneDOMElementId || "ui-page"}
                                     onChange={this.onChange} />
                <div className="flex-row-left-center">
                    <ButtonAddAttachmentLink onSelect={this.onSelect}/>
                </div>
            </div>
        )
    }
}
